import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';
import { QuizzesFacade } from '../facades/quizzes.facade';

export function quizzesCleanup<T>(): CanDeactivateFn<T> {
    return () => {
        const quizzesFacade = inject(QuizzesFacade);
        quizzesFacade.clear();

        return true;
    };
}
